import { c as _c } from "react/compiler-runtime";
import { Chip } from "@flat-ui";
/**
 * A card that summarizes the project info
 */
export function DemoTag(t0) {
  const $ = _c(2);
  const {
    sx
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = <Chip label="DEMO" color="primary" size="extraSmall" sx={sx} />;
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}